module.exports = __webpack_public_path__ + "static/media/e.6f653a53.m4a";